import React, { FC } from 'react';
import { RangeEnum } from '../../shared/types';
import { useMeasure } from '../../shared/utils';
import { Label } from '../../shared/styles';

type RangeLabelProps = {
  switchTo: boolean;
  label: string;
  type: RangeEnum;
};

const RangeLabel: FC<RangeLabelProps> = ({ label, switchTo, type }) => {
  const measure = useMeasure({ switchTo, type });
  return (
    <Label>
      {label} ({measure})
    </Label>
  );
};

export default RangeLabel;
